import { useMemo } from 'react';

import { TournamentStatus, TournamentSystem } from '@features/shared/api/typings';
import { getRoundRobinXlsUrl, getSwissXlsUrl } from '@features/tournament/api/hooks';
import { TournamentLinkBadge } from '@features/tournament/ui/components/TournamentSubHeader/badges/TournamentLinkBadge';

type Props = {
  clubId?: string;
  tournament?: {
    status: TournamentStatus;
    tournamentId: string;
    system: TournamentSystem;
  };
};

export function TournamentExcelBadge({ clubId, tournament }: Props) {
  const excelUrl = useMemo(() => {
    if (!tournament || !clubId) return null;
    if (tournament.system === 'RoundRobin') {
      return getRoundRobinXlsUrl(clubId, tournament.tournamentId);
    }
    if (tournament.system === 'Swiss') {
      return getSwissXlsUrl(clubId, tournament.tournamentId);
    }
    return null;
  }, [clubId, tournament]);

  if (!clubId || !tournament || tournament.status !== 'Finished' || !excelUrl) {
    return null;
  }

  return <TournamentLinkBadge href={excelUrl}>Результаты в XLS</TournamentLinkBadge>;
}
